const SIGN_IN_CODES = new Set([
  'session_revoked',
  'account_disabled',
  'user_not_found',
  'sign_in_required',
  'token_expired',
]);

const FORBIDDEN_CODES = new Set([
  'NOT_RECIPIENT',
  'AUTH_REQUIRED',
  'AGREEMENTS_INCOMPLETE',
]);

export function parseApiError(error) {
  const directStatus = Number(error?.status);
  const status = Number.isInteger(directStatus) && directStatus > 0
    ? directStatus
    : statusFromMessage(error?.message);
  const directCode = String(error?.code || error?.body?.code || error?.body?.error_code || '').trim();
  return {
    status,
    code: directCode || codeFromMessage(error?.message),
  };
}

function statusFromMessage(message) {
  const match = String(message || '').match(/API Error \((\d+)\)/);
  return match ? Number(match[1]) : null;
}

function codeFromMessage(message) {
  const text = String(message || '');
  const jsonStart = text.indexOf('{');
  if (jsonStart < 0) return '';
  try {
    const body = JSON.parse(text.slice(jsonStart));
    return String(body.code || body.error_code || '').trim();
  } catch {
    return '';
  }
}

export function shouldRefreshExpiredToken(error, alreadyRetried = false) {
  if (alreadyRetried) return false;
  const { status, code } = parseApiError(error);
  return status === 401 && code === 'token_expired';
}

export function classifyNotificationFailure(error) {
  const { status, code } = parseApiError(error);
  if (code === 'NOTIFICATION_EXPIRED') {
    return { status: 'rejected', message: 'This notification expired', kind: 'expired' };
  }
  if (code === 'ALREADY_CLOSED' || status === 409) {
    return { status: 'rejected', message: 'Already handled', kind: 'handled' };
  }
  if (code === 'NOT_FOUND' || status === 404) {
    return { status: 'error', message: 'This notification is no longer available', kind: 'missing' };
  }
  if (SIGN_IN_CODES.has(code) || status === 401) {
    return { status: 'error', message: 'Sign in to respond', kind: 'sign-in' };
  }
  if (FORBIDDEN_CODES.has(code) || status === 403) {
    return { status: 'error', message: 'You cannot respond to this notification', kind: 'forbidden' };
  }
  return { status: 'error', message: 'Network error — try again', kind: 'network' };
}

export function outcomeFromResult(result) {
  if (result?.accepted === true) {
    return { status: 'accepted', message: 'Response sent', kind: 'accepted' };
  }
  if (result?.code === 'NOTIFICATION_EXPIRED') {
    return { status: 'rejected', message: 'This notification expired', kind: 'expired' };
  }
  if (result?.code === 'ALREADY_CLOSED') {
    return { status: 'rejected', message: 'Already handled', kind: 'handled' };
  }
  return {
    status: 'rejected',
    message: result?.error || 'Response not accepted',
    kind: 'rejected',
  };
}
